import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TInputForm from "../../common/TInputForm";

class InterparkBookSearchForm extends Component {
    componentDidMount() {
        const { onChange } = this.props
        if (typeof this.props.data.setting.apiKey == 'undefined' || this.props.data.setting.apiKey == '') {
            onChange(
                Object.assign({}, this.props.data, {
                    validated: false
                })
            )
        }
    }

    @autobind
    handleChange(value, property) {
        const { onChange } = this.props
        var newObject = Object();
        newObject[property] = value;
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props
        return (
            <div className="desc_plugin36">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        인증키 입력
                        <TInputForm type="text" className="tf_set tf_set600" placeholder="인증키를 넣어주세요." title="인증키를 넣어주세요." value={this.props.data.setting.apiKey} onChange={(value)=>this.handleChange(value,'apiKey')}/>
                    </div>
                </div>
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            인터파크 북피니언에 가입후 인증키를 받아주세요.
                            <a href="http://book.interpark.com/blog/api/authKeyRegisterForm.rdo?null&amp;FromLogin=Y" target="_blank" className="link_other">인증키 발급받기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            입력창에 인증키를 복사해 붙여 넣으시고, 적용을 클릭하면 됩니다.
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            글쓰기 중 인터파크 상품 정보를 첨부하세요.
                        </li>
                    </ol>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

InterparkBookSearchForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default InterparkBookSearchForm
